import { FormattedMessage as FM } from "react-intl";
import dates from "componentsv2/tools/dates";
import cn from "classnames";
import { CalendarIcon, ClockIcon } from "components/Icons";

export default function TooltipCard({ event, className = "" }) {
  if (!event) return null;

  const party = event.item?.["party."]?.name || event.name;
  const patient =
    event.item?.["patient."]?.rec_name || event.patient || "Sin paciente";
  const product = event.item?.["product."]?.name || "Sin servicio";
  const typeColor = event.appointment_type?.color || "#C0C0C0";
  const room =
    event.item?.["room."]?.rec_name || event.room || "Sin habitacion";
  return (
    <div
      className={cn(
        "absolute hidden group-hover:flex flex-col px-4 py-3 text-sm rounded-xl shadow-xl z-50 top-full left-1/2 -translate-x-1/2 mt-2 w-max max-w-sm whitespace-pre-wrap border border-gray-200  bg-white  text-gray-800  transition-all duration-200 ease-in-out opacity-0 group-hover:opacity-100 group-hover:translate-y-1",
        className,
      )}
    >
      <div className="flex flex-row gap-6">
        <div className="text-left space-y-1.5">
          <TooltipRow label="Cliente" value={party} />
          <TooltipRow label="Paciente" value={patient} />
          <TooltipRow label="Servicio" value={product} />
        </div>
        <div className="text-center space-y-1.5">
          <TooltipRow
            icon={
              <CalendarIcon className="w-4 h-4 fill-current text-neutral-600" />
            }
            value={dates.fmt(event.start_date, "dd MMM yyyy")}
          />
          <TooltipRow
            icon={
              <ClockIcon className="w-4 h-4 fill-current text-neutral-600" />
            }
            value={`${dates.fmt(event.start_date, "hh:mm aa")} - ${dates.fmt(
              event.end_date,
              "hh:mm a",
            )}`}
          />
          <TooltipRow
            label={<FM id="appointment_scheduling.state" />}
            value={<FM id={`appointment_scheduling.${event.state}`} />}
          />
          <div className="flex justify-center items-center mt-3">
            <span
              className="size-5 rounded-full  border border-dotted border-gray-400"
              style={{ backgroundColor: typeColor }}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-6 px-5 py-2.5 mt-3 border-t-2 border-dashed border-gray-200">
        <span className="text-gray-500">Sala</span>
        <span className="font-semibold text-gray-600">{room}</span>
      </div>
    </div>
  );
}

function TooltipRow({ label, value, icon }) {
  return (
    <div className="flex flex-col gap-1">
      {icon ? (
        <span className="mx-auto">{icon}</span>
      ) : label ? (
        <span className="font-light text-neutral-500">{label}</span>
      ) : null}
      <span className="font-medium text-neutral-800">{value}</span>
    </div>
  );
}
